import { ReactNode } from 'react';

interface ReadonlyFieldProps {
    label: string;
    children?: ReactNode;
}

/**
 * Dato en solo lectura (design system §2.2 y §3.7): label de 12px en --text-2 arriba y el valor debajo.
 * Un valor vacío se muestra como "—". Estilos en src/scss/_design-system.scss (.md-readonly).
 */
export default function ReadonlyField({ label, children }: ReadonlyFieldProps) {
    const isEmpty = children === null || children === undefined || children === '';

    return (
        <div className="md-readonly">
            <span className="md-readonly__label">{label}</span>
            <span className="md-readonly__value">{isEmpty ? '—' : children}</span>
        </div>
    );
}
